import { AutogenModelCallin, AutogenRowCallin } from "./autogen/AutogenModelCallin";

export class ModelCallin extends AutogenModelCallin<RowCallin> {
    constructor() {
        super(RowCallin);
    }
}

export class RowCallin extends AutogenRowCallin {
}